import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import './App.css'
import IconWorker from './assets/worker.svg'
import LogoBranca from './assets/logo-branca-vertical.png'

export default function App() {
	return (
		<Container id="stx-container">
			<Row>
				<Col id="col-card" sm={12} md={12} lg={12} xl={12}>
					<img src={LogoBranca} alt="Statix Inovação e Tecnologia" id="stx-logo"/>
					<Card id="stx-card">
						<Card.Body>
							<Card.Img src={IconWorker}></Card.Img>
							<Card.Title id="card-title">Portal em Construção</Card.Title>
							<Card.Text>
								Estamos trabalhando em um novo portal da Statix, para melhor atender aos nossos clientes. Fiquem atentos às novidades!
							</Card.Text>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	)
}
